import { connect } from 'react-redux'
import ActionLogCard from '../../components/ActionLogCard'
import { getControl } from '../../store/ControlById/selectors'
import { ActionLog, State } from '../../types'

export default connect((state: State, props: { actionLog: ActionLog }) => ({
	control: getControl(state, props.actionLog.controlId),
}))(ActionLogCard)
